import { useContext, useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router';
import { GlobalContext } from '../../../context/Context';
import Style from './style.module.css';
import { motion, AnimatePresence } from "framer-motion";
import { ChevronRight, ChevronsRight } from 'lucide-react';

const AsideBar = () => {
    const location = useLocation();
    let { state } = useContext(GlobalContext);
    const [one] = useState(1);
    const [two] = useState(2);
    const leftVideoRef = useRef(null);
    const [leftLoaded, setLeftLoaded] = useState(false);
    const [allReady, setAllReady] = useState(false);
    let dashboardRole =  false//state?.user?.dashboardRole === "single";
    useEffect(() => { if (leftLoaded) { setAllReady(true); } }, [leftLoaded]);

    useEffect(() => {
        if (allReady) {
            const left = leftVideoRef.current;

            const playVideos = async () => {
                try {
                    await left?.play();
                } catch (err) {
                    console.warn("Autoplay blocked, waiting for user interaction", err);

                    // fallback: wait for user click to start
                    const handleUserInteraction = async () => {
                        await left?.play();
                        window.removeEventListener("click", handleUserInteraction);
                    };
                    window.addEventListener("click", handleUserInteraction);
                }
            };

            playVideos();
        }
    }, [allReady]);

    console.log("Location", location)

    const navItems = [
        {
            title: "Home",
            url: dashboardRole ? "#" : "#",
            isActive: location.pathname.split("/")[one] === "ppc" || location.pathname.split("/")[one] === "organization",
            icon: `${state.basePath}/dashboard/aside/png/home.png`,
            iconHover: `${state.basePath}/dashboard/aside/png/home-hover.png`,
            subMenu: false,
            // subMenuList: [
            //     { title: "Organization", url: "/ppc/organization/overview" },
            //     // { title: "Insight", url: "/ppc/organization/insight-matrices" }
            // ]
        },
        {
            title: "Stock",
            url: dashboardRole ? "#" : `/stock-and-supply-management/organization/overview`,
            isActive: location.pathname.split("/")[one] === "stock-and-supply-management",
            icon: `${state.basePath}/dashboard/aside/png/stock.png`,
            iconHover: `${state.basePath}/dashboard/aside/png/stock-hover.png`,
            subMenu: true,
            subMenuList: [
                { title: "Organization", url: "/stock-and-supply-management/organization/overview" },
                // { title: "My Team", url: "/attendance/team/overview" },
                // { title: "Organization", url: "/attendance/organization/overview" }
            ]
        },
        {
            title: "Fuel",
            url: dashboardRole ? "#" : `/fuel-inv/organization/overview`,
            isActive: location.pathname.split("/")[one] === "fuel-inv",
            icon: `${state.basePath}/dashboard/aside/png/fuel.png`,
            iconHover: `${state.basePath}/dashboard/aside/png/fuel-hover.png`,
            subMenu: true,
            subMenuList: [
                { title: "Organization", url: "/fuel-inv/organization/overview" },
                // { title: "My Team", url: "/leave/team/overview" },
                // { title: "Organization", url: "/leave/organization/overview" }
            ]
        },
        {
            title: "Tanker",
            url: dashboardRole ? "#" : `/water-tanker/organization/overview`,
            isActive: location.pathname.split("/")[one] === "water-tanker",
            icon: `${state.basePath}/dashboard/aside/png/tanker.png`,
            iconHover: `${state.basePath}/dashboard/aside/png/tanker-hover.png`,
            subMenu: true,
            subMenuList: [
                { title: "Organization", url: "/water-tanker/organization/overview" },
                // { title: "My Team", url: "/leave/team/overview" },
                // { title: "Organization", url: "/leave/organization/overview" }
            ]
        },
        {
            title: "Electricity",
            url: dashboardRole ? "#" : `/electric-bill/organization/overview`,
            isActive: location.pathname.split("/")[one] === "electric-bill",
            icon: `${state.basePath}/dashboard/aside/png/bill.png`,
            iconHover: `${state.basePath}/dashboard/aside/png/bill-hover.png`,
            subMenu: true,
            subMenuList: [
                { title: "Organization", url: "/electric-bill/organization/overview" },
                // { title: "My Team", url: "/leave/team/overview" },
                // { title: "Organization", url: "/leave/organization/overview" }
            ]
        },
        {
            title: "Assets",
            url: dashboardRole ? "#" : `/office-assets/organization/overview`,
            isActive: location.pathname.split("/")[one] === "office-assets",
            icon: `${state.basePath}/dashboard/aside/png/office-assets.png`,
            iconHover: `${state.basePath}/dashboard/aside/png/office-assets-hover.png`,
            subMenu: true,
            subMenuList: [
                { title: "Organization", url: "/office-assets/organization/overview" },
                { title: "Summary", url: "/office-assets/summary/categories" },
                // { title: "My Team", url: "/leave/team/overview" },
                // { title: "Organization", url: "/leave/organization/overview" }
            ]
        },
        // {
        //     title: "Fleet",
        //     url: dashboardRole ? "#" : `/fleet/my-space/overview`,
        //     isActive: location.pathname.split("/")[one] === "fleet",
        //     icon: `${state.basePath}/dashboard/aside/png/fleet.png`,
        //     iconHover: `${state.basePath}/dashboard/aside/png/fleet-hover.png`,
        //     subMenu: true,
        //     subMenuList: [
        //         { title: "My Space", url: "/fleet/my-space/overview" },
        //         { title: "Car", url: "/fleet/car/overview" },
        //         { title: "Van", url: "/fleet/van/overview" },
        //     ]
        // },
        // (state.user?.user_role == 1 || state.user?.user_role == 2 || state.user?.user_role == 3) &&
        // {
        //     title: "Comparisions",
        //     url: dashboardRole ? "#" : `/ppc-comparision/comparision/products`,
        //     isActive: location.pathname.split("/")[one] === "ppc-comparision",
        //     icon: `${state.basePath}/dashboard/aside/png/comparison.png`,
        //     iconHover: `${state.basePath}/dashboard/aside/png/comparison-hover.png`,
        //     subMenu: true,
        //     subMenuList: [
        //         { title: "Comparisions", url: "/ppc-comparision/comparision/products" }
        //     ]
        // },
    ].filter(Boolean);

    const [expend, setExpend] = useState(false);
    const [activeNav, setActiveNav] = useState(null);

    return (
        <motion.aside
            className={expend ? `${Style.isExpend} isExpend` : ""}
            animate={{ width: expend ? 220 : 75 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        // className={`${expend ? Style.isExpend : null}`}
        >
            <div className={`${Style.aside_top}`}>
                <div className={`${Style.aside_userProfle}`}>
                    {
                        <video
                            ref={leftVideoRef}
                            muted
                            loop
                            playsInline
                            preload="auto"
                            poster={`${state.basePath}/aside_logo.png`}
                            onLoadedData={() => setLeftLoaded(true)}
                        >
                            <source src={`${state.basePath}/q_logo.mp4`} type="video/mp4" />
                        </video>
                    }

                </div>

                <div className={Style?.aside_navBar}>
                    {navItems?.map((item, idx) => {
                        return (
                            <div
                                key={`nav_row_${idx}`}
                                className={`${Style?.nav_row}`}
                                >
                                <motion.div
                                    onClick={() => { if (item?.subMenu) { setActiveNav((prev) => (prev === idx ? null : idx)); } }}
                                    className={`${Style?.nav_button}`}
                                    animate={{
                                        flexDirection: expend ? "row" : "column",
                                        alignItems: expend ? "center" : "center",
                                        gap: expend ? "10px" : "10px"
                                    }}
                                    transition={{ duration: 0.25, ease: "easeInOut" }}
                                >
                                    <Link to={item?.url} className={`${Style?.nav_link} ${activeNav === idx ? Style.active : null} ${item?.isActive ? Style.active : ""} `}>
                                        <div className={`${Style?.icon}`}><img src={`${item?.icon}`} width={46} height={46} alt={`normal_${idx}_${item?.title}`} /></div>
                                        <div className={`${Style?.icon} ${Style?.iconHover}`}><img src={item?.iconHover} width={46} height={46} alt={`hover_${idx}_${item?.title}`} /></div>
                                    </Link>

                                    <AnimatePresence mode="wait">
                                        <motion.span
                                            key={expend ? "expanded" : "collapsed"}
                                            className={`${Style.nav_lable} truncate`}
                                            initial={{
                                                opacity: 0,
                                                x: expend ? -6 : 0,
                                                y: expend ? 0 : 6,
                                            }}
                                            animate={{ opacity: 1, x: 0, y: 0 }}
                                            exit={{
                                                opacity: 0,
                                                x: expend ? -6 : 0,
                                                y: expend ? 0 : 6,
                                            }}
                                            transition={{ duration: 0.18, ease: "easeOut" }}
                                        >
                                            {item.title}
                                        </motion.span>
                                    </AnimatePresence>
                                </motion.div>

                                <div
                                    className={`${Style.nav_subMenuWrapp} ${(!expend && Style.hoverMode) || (expend && Style.open) } ${activeNav === idx ? Style?.isOpen : null}`}
                                >
                                    <div className={`${Style?.nav_subMenuHead}`}>
                                        <img className={`${Style?.nav_subMenuIcon}`} src={`${item?.icon}`} width={26} height={26} alt={item?.title} />
                                        <span className={`${Style?.nav_subMenuLable}`}>{item?.title}</span>
                                    </div>

                                    <div className={`${Style?.nav_subMenuBody}`}>
                                        {item?.subMenuList?.map((subItems, subIdx) => {
                                            const isActive = location?.pathname?.split("/").length > 3 ? `${location?.pathname?.split("/")[1]}-${location?.pathname?.split("/")[2]}`==`${subItems?.url?.split("/")[1]}-${subItems?.url?.split("/")[2]}` : `${location?.pathname?.split("/")[1]}`==`${subItems?.url?.split("/")[1]}`
                                            return (
                                                <Link to={subItems?.url || "#"} className={`${Style?.nav_subMenuItems} ${isActive ? Style?.isActive : null}`} key={`subMenu_${idx}_${subIdx}`}>{subItems?.title}</Link>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>

                {/* <div className={Style.aside_navBar}>
                    {navItems?.map((item, idx) => {
                        return (
                            <div
                                className={`${Style.aside_navBar_btn} ${activeNav === idx ? Style.active : null}`}
                                key={`nav_Items_${idx}`}

                            >
                                <motion.div
                                    layout
                                    className={Style.aside_navBar_row}
                                    animate={{
                                        flexDirection: expend ? "row" : "column",
                                        alignItems: expend ? "center" : "center",
                                        gap: expend ? 10 : 4
                                    }}
                                    transition={{ duration: 0.25, ease: "easeInOut" }}
                                    onClick={() => { if (item?.subMenu) { setActiveNav((prev) => (prev === idx ? null : idx)); } }}
                                >
                                    <Link to={item?.url} className={`${Style.aside_navBar_items} ${item?.isActive ? Style.active : ""}`}>
                                        <div className={Style.icon}>
                                            <img src={`${item?.icon}`} width={46} height={46} alt={item?.title} />
                                        </div>
                                        <div className={`${Style.icon} ${Style.iconHover}`}>
                                            <img src={item?.iconHover} width={46} height={46} alt={item?.title} />
                                        </div>
                                    </Link>
                                    <AnimatePresence>
                                        {expend && (
                                            <motion.span
                                                className={`${Style.aside_navBar_label} truncate`}
                                                initial={{ opacity: 0, x: -6 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                exit={{ opacity: 0, x: -6 }}
                                                transition={{ duration: 0.2, ease: "easeOut" }}
                                            >
                                                {item?.title}
                                            </motion.span>
                                        )}
                                    </AnimatePresence>
                                </motion.div>

                                {(item?.subMenu && !expend) && (
                                    <div className={`${Style.aside_navBar_hover}`}>
                                        <div className="flex items-center gap-1.5 text-[#01031a] pb-0">
                                            <img src={`${item?.icon}`} width={26} height={26} alt={item?.title} />
                                            <span className='text-base font-semibold '>{item?.title}</span>
                                        </div>

                                        <div className="border-l-2 border-[#f2f2f2] ml-[12px] pl-5 pt-1 flex flex-col gap-1.5 text-left">
                                            {item?.subMenuList?.map((subItems, subIdx) => {
                                                return (
                                                    <Link to={subItems?.url || "#"} className={`${Style.aside_navBar_sub_items}`} key={`nav_Sub_Items_${idx}_${subIdx}`}>{subItems?.title}</Link>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )}

                                {item?.subMenu && expend && activeNav === idx && (
                                    <>
                                        <div className={`${Style.aside_navBar_click}`}>
                                            <div className="border-l border-[#f2f2f2b9] ml-[16px] pl-[25px] pt-1 flex flex-col gap-0.5 text-left">
                                                {item?.subMenuList?.map((subItems, subIdx) => {
                                                    return (
                                                        <Link
                                                            to={subItems?.url || "#"}
                                                            className={`${Style.aside_navBar_sub_items2}`}
                                                            key={`nav_Sub_Items_${idx}_${subIdx}`}
                                                        >
                                                            {subItems?.title}
                                                        </Link>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        )
                    })}
                </div> */}
            </div>

            <div className={Style.aside_bottom}>
                <motion.button
                    type="button"
                    className={Style.collapseBtn}
                    onClick={() => {setExpend(prev => !prev); setActiveNav(null)}}
                    whileHover={{ scale: 1.08 }}
                    whileTap={{ scale: 0.92 }}
                    aria-label={expend ? "Collapse sidebar" : "Expand sidebar"}
                    title={expend ? "Collapse sidebar" : "Expand sidebar"}
                >
                    <motion.span
                        animate={{ rotate: expend ? 180 : 0 }}
                        transition={{ duration: 0.25, ease: "easeInOut" }}
                    >
                        <ChevronsRight size={18} strokeWidth={2.2} />
                    </motion.span>
                </motion.button>
            </div>
        </motion.aside >
    )
}

export default AsideBar
